import { css } from '@emotion/react';
import React, { ReactNode } from 'react';

import { Box, BoxProps } from '../Box';
import type { ResponsiveValue } from './types';
import { generateColumnSpan } from './utils';

export interface ColumnProps extends BoxProps {
  /**
   * Column span at different breakpoints
   */
  span?: ResponsiveValue<number | 'auto'>;
  /**
   * Column start position
   */
  start?: ResponsiveValue<number>;
  /**
   * Column end position
   */
  end?: ResponsiveValue<number>;
  /**
   * Row position
   */
  row?: ResponsiveValue<number>;
  /**
   * Row span
   */
  rowSpan?: ResponsiveValue<number>;
  /**
   * Grid area name
   */
  area?: string;
  /**
   * Column children
   */
  children: ReactNode;
}

const Column = ({
  span,
  start,
  end,
  row,
  rowSpan,
  area,
  children,
  ...props
}: ColumnProps) => {
  const columnStyles = [
    span && generateColumnSpan(span),
    start &&
      css`
        grid-column-start: ${start};
      `,
    end &&
      css`
        grid-column-end: ${end};
      `,
    row &&
      css`
        grid-row: ${row};
      `,
    rowSpan &&
      css`
        grid-row: span ${rowSpan};
      `,
    area &&
      css`
        grid-area: ${area};
      `,
  ].filter(Boolean);

  return (
    <Box css={columnStyles} {...props}>
      {children}
    </Box>
  );
};

export default Column;
